import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const ChangeDetailPage = lazy(() => import('./detail-page').then((m) => ({ default: m.ChangeDetailPage })));
const ChangeFormPage = lazy(() => import('./form-page').then((m) => ({ default: m.ChangeFormPage })));
const ChangeListPage = lazy(() => import('./list-page').then((m) => ({ default: m.ChangeListPage })));

export const changeRoutes: RouteObject[] = [
  {
    path: 'changes',
    handle: { crumb: 'Change Control' },
    children: [
      { index: true, element: <ChangeListPage /> },
      { path: 'new', element: <ChangeFormPage />, handle: { crumb: 'New change' } },
      { path: ':id', element: <ChangeDetailPage />, handle: { crumb: (p: Record<string, string | undefined>) => p.id ?? 'Change' } },
    ],
  },
];
